import { DateTime } from 'luxon';
import * as IconSelector from '../icons';

const getEjercicios = () => {
    const inicio = 2025;
    const fin = DateTime.now().year;
    let newEnum = [];

    for (let i = fin; i >= inicio; i--) {
        newEnum.push({
            value: i,
            label: i,
            description: 'Ejercicio',
            icon: IconSelector.CampañaIcon,
            color: 'black'
        });
    }

    return newEnum;
};

export const ejercicios = getEjercicios();
